import { AutogenModelOrderOtherChargeQuote, AutogenRowOrderOtherChargeQuote } from "./autogen/AutogenModelOrderOtherChargeQuote";

export class ModelOrderOtherChargeQuote extends AutogenModelOrderOtherChargeQuote<RowOrderOtherChargeQuote> {
    constructor() {
        super(RowOrderOtherChargeQuote);
    }
}

export class RowOrderOtherChargeQuote extends AutogenRowOrderOtherChargeQuote {
}